module.exports = __webpack_public_path__ + "static/media/blog-post.7b4fb8bf.png";